export default "__VITE_PUBLIC_ASSET__1383ad08__"